import {createAction} from "@reduxjs/toolkit";
import {AllocatableLoadInventorySearchCriteria} from "@ots-frontend/ots-data";

export const setAllocatableLoadInventorySearchPageFilter = createAction<AllocatableLoadInventorySearchCriteria>("ui/allocatable-load-inventory-search-page/setFilter");
